// e-content-form.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';

@Component({
    selector: 'app-e-content-form',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        DynamicFormQuestionComponent,
        MatCardModule,
        ReactiveFormsModule,
    ],
    templateUrl: './e-content-form.component.html',
    styleUrls: ['./e-content-form.component.scss']
})
export class EContentFormComponent {
  @Input() questions: Inputfiledsbase<string>[] | null = [];
  @Input() form!: FormGroup;
  @Output() submitForm = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  fileToUpload: File | null = null;
  filePreview: string | null = null;
  fileName: string | null = null;
  isImage: boolean = false;

  onSubmit() {
    if (this.form.valid) {
      const formData = new FormData();

      formData.append('title', this.form.value['econtent_title']);
      formData.append('course_id', this.form.value['courses_id']);
      formData.append('semester_id', this.form.value['semister_id']);
      formData.append('subject_id', this.form.value['subject_id']);
      formData.append('category_id', this.form.value['category_id']);

      if (this.fileToUpload) {
        formData.append('econtent_media', this.fileToUpload); // 👈 Add the actual file
      }
      this.submitForm.emit(formData); // 👈 Emit full FormData to parent
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileToUpload = input.files[0];
      this.fileName = this.fileToUpload.name;
      this.isImage = this.fileToUpload.type.startsWith('image/');
      if (this.isImage) {
        const reader = new FileReader();
        reader.onload = () => {
          this.filePreview = reader.result as string;
        };
        reader.readAsDataURL(this.fileToUpload);
      } else {
        this.filePreview = null;
      }
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}
